import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import { CloseCircle } from 'iconsax-react';
import { PrimaryButon } from '../../../../components/common/button/PrimaryButon';
import { QTextArea } from '../../../../components/common/inputs/QTextArea';
import { palette } from '../../../../../theme/palette';
import { spaceBetween } from '@ui/style/style';
import { UserStatus } from '@application/common/enums/user-status';
import { updateUserAsync } from '@application/features/adminUsers/adminUserThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useForm } from 'react-hook-form';
// import { DiclinedInfoDialog } from './DiclinedInfo';
const theme = palette('light');
export const ReasonDialog = ({ open, handleClose, Reason }) => {
    const [diclineInfo, setDiclineInfo] = useState(false);
    const dispatch = useAppDispatch();
    const { user } = useAppSelector((state) => state.user);
    const { control, handleSubmit, formState: { errors } } = useForm({});
    const onSubmit = (data) => {
        if (user) {
            const updatedUser = {
                ...user,
                reason: data.reason,
                status: UserStatus.Disapproved
            };
            dispatch(updateUserAsync(updatedUser))
                .unwrap()
                .then((response) => {
                if (response) {
                    handleClose();
                    setDiclineInfo(true);
                }
            })
                .catch((error) => { });
        }
    };
    return (_jsx(_Fragment, { children: _jsx(Dialog, { open: open, onClose: handleClose, maxWidth: false, BackdropProps: {
                sx: {
                    backdropFilter: 'blur(3px)',
                    backgroundColor: 'rgba(74, 74, 74, 0.25)'
                }
            }, children: _jsx(Box, { width: { xs: 330, sm: 600, md: 717 }, children: _jsxs(Box, { sx: {
                        padding: { xs: '10px', sm: '25px' },
                        background: 'white',
                        borderBottomRightRadius: '25px',
                        borderBottomLeftRadius: '25px'
                    }, children: [_jsxs(Box, { sx: { ...spaceBetween, mb: 2 }, children: [_jsx(Typography, { fontSize: '20px', color: '#141414', fontWeight: 500, children: "Decline User" }), _jsx(IconButton, { onClick: handleClose, children: _jsx(CloseCircle, {}) })] }), _jsx(Typography, { fontSize: '18px', mb: 1, color: '#141414', fontWeight: 500, children: "Reason for decline" }), _jsx(QTextArea, { disabled: true, rows: 15, value: Reason, placeholder: 'Reason why account is declined', errormsg: errors.reason ? errors.reason.message : '' }), _jsx(Box, { width: { xs: '100%', sm: '386px' }, margin: 'auto', children: _jsx(PrimaryButon, { type: 'submit', mt: 25, onClick: handleClose, children: "Close" }) })] }) }) }) }));
};
